import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Star, Zap, Users } from "lucide-react";

// Data synced with public/emr-comparison-data.csv
const emrData = [
  {
    name: "Doxy.me Practice Management",
    rating: "4.6/5",
    reviews: 0,
    features: ["Telehealth", "CRM", "HIPAA Compliant"],
    badge: "Telehealth Leader",
    description: "Comprehensive telehealth-focused practice management with integrated CRM.",
    emrId: "doxy"
  },
  {
    name: "Kipu EMR",
    rating: "4.7/5",
    reviews: 0,
    features: ["CRM", "RCM", "Group Therapy"],
    badge: "Enterprise Scale",
    description: "Robust EMR solution for medium to large behavioral health organizations.",
    emrId: "kipu"
  },
  {
    name: "Opus",
    rating: "4.8/5",
    reviews: 0,
    features: ["AI Note-taking", "Outcome Tracking", "Insurance"],
    badge: "Most Advanced",
    description: "Advanced EMR with AI-powered features for modern behavioral health practices.",
    emrId: "opus"
  },
  {
    name: "SimplePractice",
    rating: "4.6/5",
    reviews: 0,
    features: ["Telehealth", "Client Portal", "E-Prescribing"],
    badge: "Best Value",
    description: "User-friendly platform with integrated organization management tools.",
    emrId: "simplepractice"
  },
  {
    name: "TherapyNotes",
    rating: "4.7/5",
    reviews: 0,
    features: ["HIPAA Compliant", "Scheduling", "Billing"],
    badge: "Enterprise Ready",
    description: "Comprehensive EMR designed specifically for behavioral health organizations.",
    emrId: "therapynotes"
  },
  {
    name: "Valant EHR",
    rating: "4.1/5",
    reviews: 0,
    features: ["AI Note-taking", "Outcome Tracking", "Telehealth"],
    badge: "Specialty Focus",
    description: "Specialized EMR for psychiatric and behavioral health practices.",
    emrId: "valant"
  }
];

const FeaturedEMRs = () => {
  return (
    <section className="py-20 px-4 bg-background">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Top-Rated Behavioral EMRs
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Discover the most trusted EMR systems based on expert analysis and comprehensive feature comparisons.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {emrData.map((emr, index) => (
            <Card key={index} className="relative overflow-hidden hover:shadow-lg transition-shadow duration-300 border-border flex flex-col h-full">
              <CardHeader className="pb-4">
                <div className="flex justify-between items-start mb-2">
                  <CardTitle className="text-xl font-semibold">{emr.name}</CardTitle>
                  <Badge variant="outline">
                    {emr.badge}
                  </Badge>
                </div>
                
                <div className="flex items-center space-x-2 mb-2">
                  <div className="flex items-center">
                    <Star className="w-4 h-4 text-yellow-500 fill-current" />
                    <span className="text-sm font-medium ml-1">{emr.rating}</span>
                  </div>
                </div>
                
                <p className="text-sm text-muted-foreground">{emr.description}</p>
              </CardHeader>
              
              <CardContent className="pt-0 flex-1 flex flex-col">
                <div className="mb-4">
                  <div className="flex flex-wrap gap-2">
                    {emr.features.map((feature, idx) => (
                      <Badge key={idx} variant="outline" className="text-xs">
                        {feature}
                      </Badge>
                    ))}
                  </div>
                </div>
                
                <div className="mt-auto space-y-2">
                  <Button className="w-full" variant="outline" asChild>
                    <a href={`/emr/${emr.emrId}`}>View Details</a>
                  </Button>
                  <Button variant="ghost" size="sm" className="w-full text-xs" asChild>
                    <a href={`/comparisons?emr1=${emr.emrId}`}>Compare Features</a>
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <Button variant="outline" size="lg" asChild>
            <a href="/get-recommendation">Get My Personalized Recommendation</a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FeaturedEMRs;